import { Parser } from '~/api';
import { AuditLog } from '~/api/models';
import RequestService from './request';

class AuditLogsService {
    get(req: PaginatableRequest, extraData: Record<string, any> = {}): Promise<AuditLog[]> {
        return RequestService.get('/users/:user/audit-logs', {
            ...req,
            ...extraData,
            include: ['user', 'server'],
        }).then(Parser.parse);
    }
}

export default new AuditLogsService();
